import { useFeatureFlags } from '../hooks/useFeatureFlags';

export default function FeatureFlags() {
    const { flags, loading, error, savingId, toggleFlag } = useFeatureFlags();

    return (
        <div className="min-h-screen bg-stone-50">
            {/* Page header */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-1">
                    <h1 className="text-2xl font-semibold text-stone-900">Feature Flags</h1>
                </div>
                <p className="text-sm text-stone-500">
                    Enable or disable customer-facing features. Changes take effect immediately.
                </p>
            </div>

            {error && (
                <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700">
                    {error}
                </div>
            )}

            {loading ? (
                <div className="rounded-2xl border border-stone-200 bg-white p-12 text-center shadow-sm">
                    <p className="text-stone-500">Loading feature flags…</p>
                </div>
            ) : flags.length === 0 ? (
                <div className="rounded-2xl border border-stone-200 bg-white p-12 text-center shadow-sm">
                    <p className="text-stone-500">
                        No feature flags found. Run the feature_flags migration to seed them.
                    </p>
                </div>
            ) : (
                <div className="overflow-hidden rounded-2xl border border-stone-200 bg-white shadow-sm">
                    <ul className="divide-y divide-stone-100">
                        {flags.map((flag) => {
                            const isSaving = savingId === flag.id;
                            return (
                                <li
                                    key={flag.id}
                                    className="flex items-center justify-between gap-4 px-6 py-5"
                                >
                                    <div className="min-w-0">
                                        <div className="flex items-center gap-2.5">
                                            <span className="font-semibold text-stone-900">
                                                {flag.label}
                                            </span>
                                            <code className="rounded-md bg-stone-100 px-1.5 py-0.5 text-xs font-medium text-stone-500">
                                                {flag.key}
                                            </code>
                                            <span
                                                className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
                                                    flag.enabled
                                                        ? 'bg-[#fde8f0] text-[#ee2b74]'
                                                        : 'bg-stone-100 text-stone-500'
                                                }`}
                                            >
                                                {flag.enabled ? 'Enabled' : 'Disabled'}
                                            </span>
                                        </div>
                                        {flag.description && (
                                            <p className="mt-1 text-sm text-stone-500">
                                                {flag.description}
                                            </p>
                                        )}
                                    </div>

                                    <button
                                        type="button"
                                        role="switch"
                                        aria-checked={flag.enabled}
                                        aria-label={`Toggle ${flag.label}`}
                                        disabled={isSaving}
                                        onClick={() => toggleFlag(flag.id)}
                                        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#ee2b74]/40 focus-visible:ring-offset-2 disabled:cursor-wait disabled:opacity-50 ${
                                            flag.enabled ? 'bg-[#ee2b74]' : 'bg-stone-200'
                                        }`}
                                    >
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200 ${
                                                flag.enabled ? 'translate-x-6' : 'translate-x-1'
                                            }`}
                                        />
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}